import { ConfigurationImmediateShelfPriorityAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-immediate-shelf-priority-assignment/configuration-immediate-shelf-priority-assignment.dto'

export interface ConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState {
    immediateShelfPriorityAssignment: Partial<ConfigurationImmediateShelfPriorityAssignmentResponse>
}
export const initialConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState =
    (): ConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState => ({
        immediateShelfPriorityAssignment: {}
    })
